import { Injectable } from "@angular/core";
import { PractitionerStatus } from "src/app/ui/models/domains/pbm/practitioner-management/practitioner-status";
import { AbstractParser } from "../../parser";
import { parsePractitionerStatusList } from "./practitioner-management-parse-function";

@Injectable()
export class PractitionerStatusParser extends AbstractParser<PractitionerStatus[]> {
  parse(payload: any): PractitionerStatus[] {
    return parsePractitionerStatusList(payload);
  }
}
